import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import * as selectorsGlobal from '@redux/global/selectors';
import * as actionsGridView from 'common/components/grid-view/controllers/actions';

import {
  checkSearchAssetForMember,
  pathnameAssetForMember,
  updateSearchText,
} from 'pages/home/utils';

import { useDefaultSearchText } from 'pages/home/utils';

export const useEntitySearch = ({ initialValue } = {}) => {
  //* use state when it is ready - not now
  // const [search, setSearch] = useState(
  //   initialValue || {
  //     searchText: '',
  //     primaryFieldsOnly: false,
  //   }
  // );

  // const handleSearch = ({ searchText, primaryFieldsOnly }) => {
  //   setSearch({
  //     searchText,
  //     primaryFieldsOnly,
  //   });
  // };

  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location.pathname;

  const { getDefaultSearchText } = useDefaultSearchText();
  const defaultSearchText = getDefaultSearchText(window.location.pathname);

  const searchAllItems = useSelector(selectorsGlobal.selectSearchAllItems());

  const isSearchAssetForMember = checkSearchAssetForMember(pathname);

  const search = useSelector(selectorsGlobal.selectSelectSearchText());

  const handleSearch = (searchText, primaryFieldsOnly) => {
    if (isSearchAssetForMember) {
      updateSearchText(
        dispatch,
        searchText,
        pathnameAssetForMember,
        true,
        primaryFieldsOnly
      );
    } else {
      updateSearchText(dispatch, searchText, pathname, true, primaryFieldsOnly);
    }

    // dispatch(actionsGridView.resetPageCurrent());
    dispatch(actionsGridView.resetPageCurrentKeepPageSize());
    dispatch(actionsGridView.updateVisibleSelection(false));
    dispatch(actionsGridView.updateItemsSelectionDialog(null));
    dispatch(actionsGridView.updatePagesSelection([]));
    dispatch(actionsGridView.updateItemPageSelection([]));

    dispatch(actionsGridView.updateCountPageSelection([]));
    dispatch(actionsGridView.updateAgGridItemsSelection(0));
    dispatch(actionsGridView.updateItemCurrentSelection(null));

    dispatch(actionsGridView.toggleRefreshQuery(true));
    dispatch(actionsGridView.updateSizeCurrent([1, 0])); // check more

    // prevent call api grid view in folder
    dispatch(actionsGridView.togglePreventCallApiGridView(false)); // check more
    dispatch(actionsGridView.updateIsSelectAllSearchResult(false));
    // resetFolderBreadcrumb();
    // reloadPage();
  };

  return { ...search, defaultSearchText, searchAllItems, handleSearch };
};
